import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service';

@Component({ template: '' })
export class LogoutCallbackComponent implements OnInit {
  private dataService = inject(DataService) as DataService;
  private router = inject(Router);

  constructor() {}

  ngOnInit(): void {
    // Jetzt ist der IdP-Logout passiert → lokales Aufräumen
    try {
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('expires_at');
      localStorage.clear();
      sessionStorage.removeItem('discovery_document');
    } catch {}

    this.dataService.isAuthenticated();
    this.router.navigateByUrl('/');
  }
}
